import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { DayOfWeekName } from '../design-system/DaysOfWeekField'
import { dayOfWeekMap } from '../constants'

/**
 * The seven day names in the app's language, indexed Sunday-first the way the product numbers days.
 * `dayOfWeekMap` already holds both the short and the full i18n id, so callers that want only the
 * short form map over the result rather than deriving it again.
 */
export function useDayNames(): DayOfWeekName[] {
  const { formatMessage } = useIntl()

  return useMemo(() => dayOfWeekMap.map((day) => ({ short: formatMessage({ id: day.shortName }), full: formatMessage({ id: day.name }) })), [formatMessage])
}
